import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { AlertData } from './alert-data.interface';
import {
  CloseIconComponent,
  DangerIconComponent,
  TickIconComponent,
  InfoIconComponent,
  HoldIconComponent,
} from '@kuiper/icons';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'lib-alert-inline',
  imports: [
    CloseIconComponent,
    DangerIconComponent,
    TickIconComponent,
    InfoIconComponent,
    HoldIconComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './alert-inline.component.html',
  styleUrl: './alert-inline.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AlertInlineComponent {
  alertData = input.required<AlertData>();
  hasCloseIcon = input<boolean>(true);
  hasIcon = input<boolean>(false);
  iconTemplate = input<TemplateRef<unknown>>();
  protected isShownAlert = true;
  handleAlertClose = output<boolean>();
  hasContent = input<boolean>(false);
  alertClass = input<string>('');

  protected closeAlert() {
    this.isShownAlert = false;
    this.handleAlertClose.emit(false);
  }
}
